import React, {
  useCallback,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { PlusOutlined } from '@ant-design/icons';

import FormsSummaryCards from './FormsSummaryCards';
import FormsHomeApproveSection from './FormsHomeApproveSection';
import FormsHomeAssignedSection from './FormsHomeAssignedSection';
import FormsHomeDraftsSection from './FormsHomeDraftsSection';
import FormsHomeManualFormSection from './FormsHomeManualFormSection';
import FormsHomeLogSection from './FormsHomeLogSection';
import FormsHomeAdditionalSection from './FormsHomeAdditionalSection';

import OnTraccrButton from '../../common/buttons/OnTraccrButton';
import Permissions from '../../auth/Permissions';
import { ReactComponent as WorkflowIcon } from '../../assets/icons/workflows.svg';

import {
  getFormApprovalSummary,
  getForms,
} from '../state/forms.actions';

import './formsHome.less';

export default function FormsHome({
  history,
  onCardColumnClick,
  range,
  counts,
  trends,
}) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getFormApprovalSummary());
    if (range?.[0] && range?.[1]) {
      dispatch(getForms({
        startTime: range[0],
        endTime: range[1],
      }));
    }
  }, [range]);

  const onNavigate = useCallback((path) => {
    history.push(path);
  }, [history]);

  return (
    <div className="forms-home">
      <header className="forms-home-header">
        <div>
          <h1 className="forms-subpage-title">Forms</h1>
          <p className="forms-subpage-subtitle">
            Jump straight into the workflow you came here for.
          </p>
        </div>
        <div className="forms-home-header-actions">
          {Permissions.has('FORMS_READ_TEMPLATES') && (
            <OnTraccrButton
              title="Automate workflows"
              type="secondary"
              icon={(
                <div className="forms-home-header-automate-button-icon">
                  <WorkflowIcon className="forms-home-header-workflow-icon" />
                </div>
              )}
              iconLeft
              onClick={() => history.push('/forms/templates')}
              className="forms-home-header-automate-button"
            />
          )}
          <OnTraccrButton
            title="Start form"
            type="primary"
            icon={<PlusOutlined />}
            iconLeft
            onClick={() => history.push('/forms/manual')}
            className="forms-home-header-start-form-button"
          />
        </div>
      </header>

      <FormsSummaryCards
        counts={counts}
        trends={trends}
        onNavigate={onNavigate}
      />

      <FormsHomeApproveSection onCardColumnClick={onCardColumnClick} history={history} />
      <FormsHomeAssignedSection onCardColumnClick={onCardColumnClick} history={history} />
      <FormsHomeDraftsSection history={history} />
      <FormsHomeManualFormSection history={history} />
      <FormsHomeLogSection
        history={history}
        onCardColumnClick={onCardColumnClick}
        range={range}
      />
      <FormsHomeAdditionalSection history={history} />
    </div>
  );
}

FormsHome.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  onCardColumnClick: PropTypes.func.isRequired,
  range: PropTypes.arrayOf(PropTypes.number),
  counts: PropTypes.shape({
    approve: PropTypes.number,
    assigned: PropTypes.number,
    drafts: PropTypes.number,
    submitted: PropTypes.number,
    log: PropTypes.number,
  }).isRequired,
  trends: PropTypes.shape({
    approve: PropTypes.string,
    assigned: PropTypes.string,
    drafts: PropTypes.string,
    submitted: PropTypes.string,
    log: PropTypes.string,
  }),
};

FormsHome.defaultProps = {
  range: null,
  trends: {},
};
